import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { API_BASE_URL } from "./config";

const AdminDashboard = () => {
  const [benefits, setBenefits] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const checkAdminStatus = useCallback(async () => {
    try {
      const token = localStorage.getItem("token");
      const res = await axios.get(`${API_BASE_URL}/api/admin/check`, {
        headers: { Authorization: `Bearer ${token}` }
      });

      if (!res.data.isAdmin) {
        navigate("/home");
      }
    } catch (err) {
      navigate("/home");
    }
  }, [navigate]);

  const fetchBenefits = useCallback(async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/api/benefits`);
      setBenefits(res.data);
      setLoading(false);
    } catch (err) {
      setError("Failed to fetch benefits");
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchBenefits();
    checkAdminStatus();
  }, [fetchBenefits, checkAdminStatus]);

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this benefit?")) {
      try {
        const token = localStorage.getItem("token");
        await axios.delete(`${API_BASE_URL}/api/benefits/${id}`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        fetchBenefits();
      } catch (err) {
        setError("Failed to delete benefit");
      }
    }
  };

  if (loading) return <div className="container mt-4">Loading...</div>;

  return (
    <div className="container mt-4">
      <h2>Admin Dashboard - Benefits Management</h2>
      
      <div className="mb-4">
        <button 
          className="btn btn-primary"
          onClick={() => navigate("/admin/create-benefit")}
        >
          Create New Benefit
        </button>
      </div>

      {error && <div className="alert alert-danger">{error}</div>}

      <div className="table-responsive">
        <table className="table table-striped">
          <thead>
            <tr>
              <th>Benefit ID</th>
              <th>Name</th>
              <th>Image</th>
              <th>Description</th>
              <th>Access URL</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {benefits.length === 0 ? (
              <tr>
                <td colSpan="6" className="text-center">No benefits created yet</td>
              </tr>
            ) : (
              benefits.map(benefit => (
                <tr key={benefit._id}>
                  <td>{benefit.benefitId}</td>
                  <td>{benefit.name}</td>
                  <td>
                    <img 
                      src={`${API_BASE_URL}/${benefit.image}`} 
                      alt={benefit.name}
                      style={{ width: "50px", height: "50px", objectFit: "cover" }}
                    />
                  </td>
                  <td>{benefit.description.substring(0, 50)}...</td>
                  <td>
                    <a href={benefit.accessUrl} target="_blank" rel="noopener noreferrer">
                      View
                    </a>
                  </td>
                  <td>
                    <button 
                      className="btn btn-sm btn-warning me-2"
                      onClick={() => navigate(`/admin/edit-benefit/${benefit._id}`)}
                    >
                      Edit
                    </button>
                    <button 
                      className="btn btn-sm btn-danger"
                      onClick={() => handleDelete(benefit._id)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AdminDashboard;